import { render, staticRenderFns } from "./App.vue?vue&type=template&id=90b1038c&scoped=true&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=90b1038c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b1038c",
  null
  
)

export default component.exports